/** Implemented by Monmon */
document.addEventListener('DOMContentLoaded', () => {
    const blocks = [...document.querySelectorAll('.three-d-animation__block')];
    const videos = [...document.querySelectorAll('.three-d-animation__video')];
    const videoDurations = new Map();
    let current = 0;
    let videosLoaded = false;
    let rafId = null;
    let timeoutId = null;

    let isMobile = window.innerWidth <= 768;
    window.addEventListener('resize', () => {
        const wasMobile = isMobile;
        isMobile = window.innerWidth <= 768;
        
        if (wasMobile !== isMobile && videosLoaded) {
            videos.forEach((video, index) => {
                const currentTime = video.currentTime;
                const wasPlaying = !video.paused;
                video.load();
                video.currentTime = currentTime;
                if (wasPlaying) {
                    video.play();
                }
            });
        }
    });

    videos[0].classList.add('three-d-animation__video--active');
    blocks[0].classList.add('three-d-animation__block--active');

    const observer = new IntersectionObserver(([entry]) => {
        if (entry.isIntersecting && !videosLoaded) {
            videosLoaded = true;
            observer.disconnect();
            initializeVideos();
        }
    }, { threshold: 0.1, rootMargin: '200px' });

    observer.observe(document.querySelector('.three-d-animation'));

    function initializeVideos() {
        let loaded = 0;
        const onMetadata = (video, index) => {
            videoDurations.set(index, video.duration);
            if (++loaded === videos.length) {
                activateBlock(0);
            }
            video.removeEventListener('loadedmetadata', onMetadata);
        };

        videos.forEach((video, index) => {
            video.addEventListener('loadedmetadata', () => onMetadata(video, index));
            video.load();
        });
    }

    function updateLoader(loader, video, duration) {
        const progress = video.currentTime / duration;
        loader.style.transform = `scaleX(${progress})`;
        if (progress < 1) {
            rafId = requestAnimationFrame(() => updateLoader(loader, video, duration));
        }
    }

    function switchVideo(video, otherVideos) {
        return new Promise((resolve) => {
            video.currentTime = 0;
            const playPromise = video.play();

            if (playPromise !== undefined) {
                playPromise.then(() => {
                    video.classList.add('three-d-animation__video--active');
                    requestAnimationFrame(() => {
                        otherVideos.forEach(v => {
                            v.pause();
                        });
                        
                        otherVideos.forEach(v => {
                            v.classList.remove('three-d-animation__video--active');
                        });
                        resolve();
                    });
                }).catch(console.error);
            }
        });
    }

    function activateBlock(index) {
        cancelAnimationFrame(rafId);
        clearTimeout(timeoutId);

        const duration = videoDurations.get(index);
        const currentVideo = videos[index];
        const otherVideos = videos.filter((_, i) => i !== index);
        const loader = blocks[index].querySelector('.three-d-animation__timer-progress');

        const nextIndex = (index + 1) % videos.length;
        videos[nextIndex].load();

        blocks.forEach((block, i) => {
            const isActive = i === index;
            block.classList.toggle('three-d-animation__block--active', isActive);
            const blockLoader = block.querySelector('.three-d-animation__timer-progress');
            blockLoader.style.visibility = isActive ? 'visible' : 'hidden';
            blockLoader.style.transform = 'scaleX(0)';
        });

        if (window.innerWidth <= 768) {
            const container = document.querySelector('.three-d-animation__content');
            container.scrollTo({
                left: blocks[index].offsetLeft,
                behavior: 'smooth'
            });
        }

        if (videosLoaded) {
            switchVideo(currentVideo, otherVideos);
            updateLoader(loader, currentVideo, duration);
            let new_duration = duration * 1000;
            timeoutId = setTimeout(() => {
                current = (index + 1) % blocks.length;
                activateBlock(current);
            }, new_duration);
        }
        
        current = index;
    }

    if (window.matchMedia('(max-width: 768px)').matches) {
        const container = document.querySelector('.three-d-animation__content');
        let scrollTimeout;
        
        container.addEventListener('scroll', () => {
            clearTimeout(scrollTimeout);
            scrollTimeout = setTimeout(() => {
                const scrollLeft = container.scrollLeft;
                const blockWidth = container.offsetWidth;
                const newIndex = Math.round(scrollLeft / blockWidth);
                
                if (newIndex !== current) {
                    clearTimeout(timeoutId);
                    activateBlock(newIndex);
                }
            }, 150);
        });
    }

    blocks.forEach((block, index) => {
        block.addEventListener('click', () => {
            clearTimeout(timeoutId);
            activateBlock(index);
        });
    });
}); 